/*
 * Module for the Member Enrollment Index Page
*/

rs.module("participant/memberenrollment/index",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        var _codeValues;

        var _form;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, codeValues, backendUrls, duplicatePersonLookup) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _codeValues = codeValues;
            _backendUrls = backendUrls;

            _form = $.js(_jsSelectors.form);

            // Register click event for changing identity once an identity has previously been verified
            _form.js(_jsSelectors.changeIdentityLink).click(function () { _togglePageForIdentityVerified(false); });

            // Register demographic checkboxes' change events
            _form.js(_jsSelectors.disabilityCheckbox).change(_toggleDisability);
            _form.js(_jsSelectors.studentCheckbox).change(_toggleStudent);

            // Register fund select change event
            _form.js(_jsSelectors.fundSelect).change(function () {

                // populate employers on fund change
                selectHelper.getHelper(_form.js(_jsSelectors.employerSelect)).loadOptionsFrom(
                    _backendUrls.getAvailableEmployers,
                    {
                        fundKey: $(this).val()
                    },
                    {
                        withBlank: true
                    });

                // clear plans drop down
                selectHelper.getHelper(_form.js(_jsSelectors.planSelect)).clearOptions();
            });

            // Register employer select change event
            _form.js(_jsSelectors.employerSelect).change(function () {

                // populate plans on employer change
                selectHelper.getHelper(_form.js(_jsSelectors.planSelect)).loadOptionsFrom(
                    _backendUrls.getAvailablePlans,
                    {
                        fundKey: _form.js(_jsSelectors.fundSelect).val(),
                        employerKey: $(this).val()
                    },
                    {
                        withBlank: true
                    });
            });

            // Register change event on hire date to default participation and contribution begin dates
            _form.js(_jsSelectors.hireDate).change(function () {
                _form.js(_jsSelectors.longevityDate).val($(this).val());
                _form.js(_jsSelectors.participationBeginDate).val($(this).val());
                _form.js(_jsSelectors.contributionDate).val($(this).val());
            });

            // Tell duplicate person lookup where to pull lookup parameters from
            duplicatePersonLookup.onGetLookupParameters(function () {

                // Validate form before performing duplicate lookup
                var validator = _form.validate();
                var isValid = validator.form();

                // only send lookup parameters if form is valid
                if (isValid) {
                    return {
                        isPerson: true,
                        nonPersonType: null,
                        tin: _form.js(_jsSelectors.ssn).val().replace(/-/g, "").replace(/ /g, ""),
                        firstName: _form.js(_jsSelectors.firstName).val().trim(),
                        lastName: _form.js(_jsSelectors.lastName).val().trim(),
                        nonPersonName: null
                    }
                }

                return null;
            });

            // Hookup callback function to be executed when duplicate selection is complete
            duplicatePersonLookup.onDuplicateSelectionComplete(_duplicateSelectionComplete);
        }

        //
        // Callback to execute when duplicate selection is complete
        //
        function _duplicateSelectionComplete(participantKey) {

            // set hidden fields to be able to post values back on save since we will be disabling the identity fields
            _form.js(_jsSelectors.prefixHidden).val(_form.js(_jsSelectors.prefix).val().trim());
            _form.js(_jsSelectors.firstNameHidden).val(_form.js(_jsSelectors.firstName).val().trim());
            _form.js(_jsSelectors.middleNameHidden).val(_form.js(_jsSelectors.middleName).val().trim());
            _form.js(_jsSelectors.lastNameHidden).val(_form.js(_jsSelectors.lastName).val().trim());
            _form.js(_jsSelectors.suffixHidden).val(_form.js(_jsSelectors.suffix).val().trim());
            _form.js(_jsSelectors.ssnHidden).val(_form.js(_jsSelectors.ssn).val().trim());

            // If an existing participant was not selected
            if (participantKey == -1) {

                // reset other fields for a new person
                _resetFieldsForNoMatch();
            }
            else {

                // Retrieve existing person/nonperson info
                $.get(_backendUrls.loadExistingPersonInfo,
                    {
                        participantKey: participantKey

                    }).done(function (result) {

                        // clear demographics and contact info up front
                        _clearFields();

                        _form.js(_jsSelectors.participantKeyHidden).val(result.person.personKey);
                        _form.js(_jsSelectors.updateTokenHidden).val(result.person.updateToken);

                        // populate identity inputs with the retrieved info for the duplicate person
                        _form.js(_jsSelectors.prefix).val(result.person.namePrefix);
                        _form.js(_jsSelectors.firstName).val(result.person.firstName);
                        _form.js(_jsSelectors.middleName).val(result.person.middleName);
                        _form.js(_jsSelectors.lastName).val(result.person.lastName);
                        _form.js(_jsSelectors.suffix).val(result.person.nameSuffix);

                        // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                        _form.js(_jsSelectors.prefixHidden).val(result.person.namePrefix);
                        _form.js(_jsSelectors.firstNameHidden).val(result.person.firstName);
                        _form.js(_jsSelectors.middleNameHidden).val(result.person.middleName);
                        _form.js(_jsSelectors.lastNameHidden).val(result.person.lastName);
                        _form.js(_jsSelectors.suffixHidden).val(result.person.nameSuffix);

                        // only overwrite ssn if the retrieved person has one already - if null, leave user entered value
                        if (result.person.ssn) {
                            _form.js(_jsSelectors.ssn).val(result.person.ssn);
                            _form.js(_jsSelectors.ssnHidden).val(result.person.ssn);
                        }

                        // populate demographic fields with retrieved info for the duplicate person
                        _form.js(_jsSelectors.birthDatePicker).val(result.person.birthDate ? new Date(result.person.birthDate).toISODateString() : null);
                        _form.js(_jsSelectors.birthCertFiledCheckbox).setChecked(result.person.birthCertifFiled);
                        _form.js(_jsSelectors.birthCityInput).val(result.person.birthPlace);
                        selectHelper.getHelper(_form.js(_jsSelectors.birthStateSelect)).setValue(result.person.birthState ? result.person.birthState.key : null);
                        _form.js(_jsSelectors.birthCountyInput).val(result.person.birthCounty);
                        selectHelper.getHelper(_form.js(_jsSelectors.genderSelect)).setValue(result.person.gender ? result.person.gender.key : null);
                        selectHelper.getHelper(_form.js(_jsSelectors.maritalStatusSelect)).setValue(result.person.maritalStatus ? result.person.maritalStatus.key : null);
                        _form.js(_jsSelectors.disabilityCheckbox).setChecked(result.person.disabled);
                        selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setValue(result.person.disabilityType ? result.person.disabilityType.key : null);
                        _form.js(_jsSelectors.disabilityDatePicker).val(result.person.disabledCertifFiledDate ? new Date(result.person.disabledCertifFiledDate).toISODateString() : null);
                        _form.js(_jsSelectors.studentCheckbox).setChecked(result.person.fullTimeStudent);
                        _form.js(_jsSelectors.studentDatePicker).val(result.person.fTStudentCertifFiledDate ? new Date(result.person.fTStudentCertifFiledDate).toISODateString() : null);

                        // default contact info values for user convinience (these may get overridden based on the existence of a home address)
                        selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(_codeValues.usa);
                        _form.js(_jsSelectors.countryCodeInput).val("1");

                        // reset keys to -1 (if the contact info exists, the hidden field will get set to the existing key below)
                        _form.js(_jsSelectors.addressKeyHidden).val(-1);
                        _form.js(_jsSelectors.emailKeyHidden).val(-1);
                        _form.js(_jsSelectors.phoneKeyHidden).val(-1);

                        if (result.homeAddress) {
                            _form.js(_jsSelectors.enterManually).setChecked(result.homeAddress.avasOverrideFlag);
                            _form.js(_jsSelectors.avasOverride).setChecked(result.homeAddress.avasOverrideFlag);

                            // setTimeout(0) allows the callback for avasOverride in avas.js to resolve before setting these values
                            setTimeout(() => { 
                                _form.js(_jsSelectors.addressKeyHidden).val(result.homeAddress.addressKey);

                                _form.js(_jsSelectors.address1Input).val(result.homeAddress.address1);
                                _form.js(_jsSelectors.address2Input).val(result.homeAddress.address2);
                                _form.js(_jsSelectors.cityInput).val(result.homeAddress.city);
                                _form.js(_jsSelectors.cityHiddenInput).val(result.homeAddress.city);
                                selectHelper.getHelper(_form.js(_jsSelectors.stateSelect)).setValue(result.homeAddress.state ? result.homeAddress.state.key : null);
                                _form.js(_jsSelectors.stateHiddenInput).val(result.homeAddress.state ? result.homeAddress.state.key : null);
                                _form.js(_jsSelectors.zipInput).val(result.homeAddress.zipCode.trim());
                                _form.js(_jsSelectors.zipHiddenInput).val(result.homeAddress.zipCode.trim());
                                selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(result.homeAddress.country ? result.homeAddress.country.key : null);
                                _form.js(_jsSelectors.countryHiddenInput).val(result.homeAddress.country ? result.homeAddress.country.key : null);
                                _form.js(_jsSelectors.mailStopInput).val(result.homeAddress.mailStop);
                            }, 0);
                        }

                        if (result.homeEmail) {

                            _form.js(_jsSelectors.emailKeyHidden).val(result.homeEmail.emailKey);

                            _form.js(_jsSelectors.emailInput).val(result.homeEmail.emailAddress);
                        }

                        if (result.homePhone) {

                            _form.js(_jsSelectors.phoneKeyHidden).val(result.homePhone.phoneKey);

                            _form.js(_jsSelectors.countryCodeInput).val(result.homePhone.trimmedCountryCode);
                            _form.js(_jsSelectors.areaCodeInput).val(result.homePhone.trimmedAreacode);
                            _form.js(_jsSelectors.phoneNumberInput).val(result.homePhone.phoneNumber.trim());
                            _form.js(_jsSelectors.extensionInput).val(result.homePhone.trimmedExtension);
                        }

                        // set delivery method
                        selectHelper.getHelper(_form.js(_jsSelectors.deliveryMethodSelect)).setValue(result.deliveryMethod.key);
                                                
                        // Once all inputs are populated toggle sections/fields for identity verified
                        _togglePageForIdentityVerified(true);
                    });
            }

            // Move focus to Birthdate picker for quicker data entry
            _form.js(_jsSelectors.birthDatePicker).focus();
        }

        //
        // Enable/disable sections based on whether identity has been verified
        //
        function _togglePageForIdentityVerified(identityVerified) {

            _form.js(_jsSelectors.identityVerified).val(identityVerified);
            _form.js(_jsSelectors.saveButton).setDisabled(!identityVerified);

            _toggleIdentitySection(!identityVerified);
            _toggleDemographicsSection(identityVerified);
            _toggleSectionFields(_jsSelectors.contactInfo, identityVerified);
            _toggleSectionFields(_jsSelectors.employment, identityVerified);
            _resetValidations();
        }

        //
        // Helper method to enable/disable all fields in a section
        //
        function _toggleSectionFields(sectionSelector, enable) {
            // enable/disable all non-hidden inputs in the section
            _form.js(sectionSelector).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable).clearErrors();

            // Have to use select helper to handle any selects
            _form.js(sectionSelector).find("select").each(function () {
                $(this).attr("data-val", enable).clearErrors();
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });

            // Phone and email inputs are unique, we always want data-val=false due to the conditionl nature of their validations
            _form.js(_jsSelectors.phoneInput, { multiple: true }).attr("data-val", false);
            _form.js(_jsSelectors.emailInput).attr("data-val", false);
        }

        //
        // Enable/disable the identity section
        //
        function _toggleIdentitySection(enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(_jsSelectors.identity).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable);

            // Have to use select helper to enable/disable any selects
            _form.js(_jsSelectors.identity).find("select").each(function () {
                $(this).attr("data-val", enable);
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });

            _form.js(_jsSelectors.duplicatePersonLookup).toggle(enable);
            _form.js(_jsSelectors.changeIdentityLink).toggleClass(_cssClasses.visible, !enable);
        }

        //
        // Enable/disable the demographics section
        //
        function _toggleDemographicsSection(enable) {

            if (enable) {

                // enable/disable all non-hidden inputs in the section
                _form.js(_jsSelectors.demographics).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable);

                // Have to use select helper to disable any selects
                _form.js(_jsSelectors.demographics).find("select").each(function () {
                    $(this).attr("data-val", enable);
                    selectHelper.getHelper($(this)).setDisabled(!enable);
                });

                // enable/disable disability fields based on checkbox
                var disabilityChecked = _form.js(_jsSelectors.disabilityCheckbox).is(":checked");
                selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setDisabled(!disabilityChecked);
                _form.js(_jsSelectors.disabilityDatePicker).prop("disabled", !disabilityChecked);

                // enable/disable student field based on checkbox
                var studentChecked = _form.js(_jsSelectors.studentCheckbox).is(":checked");
                _form.js(_jsSelectors.studentDatePicker).prop("disabled", !studentChecked);
            }
            else {
                _toggleSectionFields(_jsSelectors.demographics, false);
            }
        }

        //
        // Set up fields if there was no match selected
        //
        function _resetFieldsForNoMatch() {
            _clearFields();

            // reset keys to -1
            _form.js(_jsSelectors.participantKeyHidden).val(-1);
            _form.js(_jsSelectors.updateTokenHidden).val(null);
            _form.js(_jsSelectors.addressKeyHidden).val(-1);
            _form.js(_jsSelectors.emailKeyHidden).val(-1);
            _form.js(_jsSelectors.phoneKeyHidden).val(-1);

            // default contact info values for user convinience
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(_codeValues.usa);
            _form.js(_jsSelectors.countryCodeInput).val("1");

            // default delivery method
            selectHelper.getHelper(_form.js(_jsSelectors.deliveryMethodSelect)).setValue(_codeValues.mail);

            _togglePageForIdentityVerified(true);
        }

        //
        // Clear all demographics and contact info inputs (used when changing the member's identity)
        //
        function _clearFields() {

            // clear address inputs 
            _form.js(_jsSelectors.address1Input).val(null);
            _form.js(_jsSelectors.address2Input).val(null);
            _form.js(_jsSelectors.cityInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.stateSelect)).setValue(null);
            _form.js(_jsSelectors.zipInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(null);
            _form.js(_jsSelectors.mailStopInput).val(null);

            // clear phone inputs 
            _form.js(_jsSelectors.countryCodeInput).val(null);
            _form.js(_jsSelectors.areaCodeInput).val(null);
            _form.js(_jsSelectors.phoneNumberInput).val(null);
            _form.js(_jsSelectors.extensionInput).val(null);

            // clear email inputs 
            _form.js(_jsSelectors.emailInput).val(null);

            // clear demographic fields
            _form.js(_jsSelectors.birthDatePicker).val(null);
            _form.js(_jsSelectors.birthCertFiledCheckbox).setChecked(false);
            _form.js(_jsSelectors.birthCityInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.birthStateSelect)).setValue(null);
            _form.js(_jsSelectors.birthCountyInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.genderSelect)).setValue(null);
            selectHelper.getHelper(_form.js(_jsSelectors.maritalStatusSelect)).setValue(null);
            _form.js(_jsSelectors.disabilityCheckbox).setChecked(false);
            selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setValue(null);
            _form.js(_jsSelectors.disabilityDatePicker).val(null);
            _form.js(_jsSelectors.studentCheckbox).setChecked(false);
            _form.js(_jsSelectors.studentDatePicker).val(null);
        }

        //
        // Toggle disability fields based on disability checkbox
        //
        function _toggleDisability() {

            var checked = _form.js(_jsSelectors.disabilityCheckbox).is(":checked");
            var disabilityTypeHelper = selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect));
            var disabilityDatePicker = _form.js(_jsSelectors.disabilityDatePicker);

            disabilityTypeHelper.setDisabled(!checked);
            disabilityDatePicker.prop("disabled", !checked);

            if (!checked) {
                disabilityTypeHelper.setValue("");
                disabilityDatePicker.val("");
            }
        }

        //
        // Toggle full time student fields based on full time student checkbox
        //
        function _toggleStudent() {

            var checked = _form.js(_jsSelectors.studentCheckbox).is(":checked");
            var studentDatePicker = _form.js(_jsSelectors.studentDatePicker);

            studentDatePicker.prop("disabled", !checked);

            if (!checked) {
                studentDatePicker.val("");
            }
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            $.validator.resetValidation(_form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);